import { Options, Vue } from 'vue-class-component';
import ToggleSwitch from '@/shared/components/toggle-switch/index.vue';
import { QuillEditor } from '@vueup/vue-quill';
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import Popover from '@/shared/components/popover/index.vue';
import { Inject } from 'vue-property-decorator';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import { TrustAPI } from '@/shared/modules/trust-api';
import { AppInsights } from '@/trust-admin-app/appInsights';
import { PageContent } from '@/shared/modules/typescript-trustapi-client/models';


/**
 *
 * @export
 * @class HelpEdit
 * @extends {Vue}
 * @prop {Object} helpContent: The help content to edit (title, body, etc)
 * @prop {Number} contentType: The type of help content to edit, 1 = help page, 2 = popovers
 */
@Options({
  props: {
    helpContent: Object,
  },
  components: {
    ToggleSwitch,
    LoadingIndicator,
    QuillEditor,
    Popover,
  },
})
export default class HelpEditModal extends Vue {
  private helpContent!: PageContent;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  private isClosing = false;
  private isSaving = false;
  private ai = new AppInsights;

  private tempHelpContent: PageContent = {};
  private isPreviewing = false;

  private isPopover = false;

  private blankToolbar = [];
  private toolbarOptions = [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
    // [{ 'direction': 'rtl' }],                         // text direction

    // [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    // ['link'],
    // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    // [{ 'font': [] }],
    [{ 'align': [] }],
    ['link', 'image', 'video'],
    // ['clean']                                         // remove formatting button
  ];

  private toolbarPopovers = [
    [{ 'header': [false] }],
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    ['link'],
  ];

  mounted(): void {
    document.body.classList.add('modal-open');
    document.addEventListener('keydown', this.onEscape);
    this.$nextTick(() => {
      console.log(this.helpContent);
      this.tempHelpContent = JSON.parse(JSON.stringify(this.helpContent));
      this.isPopover = this.tempHelpContent.contentType?.id === 2;
    });
  }

  beforeUnmount(): void {
    document.body.classList.remove('modal-open');
    document.removeEventListener('keydown', this.onEscape);
  }

  private onEscape(e: KeyboardEvent) {
    if (e.key.toLowerCase() === 'escape') {
      this.close();
    }
  }

  private close() {
    this.isClosing = true;
    setTimeout(() => {
      this.$emit('close');
    }, 500);
  }

  private checkNote() {
    // if (this.editorContent !== this.meetingNote ) {
    //   this.unsavedNote = true;
    // }
  }

  private async saveContent(): Promise<void> {
    try {
      this.isSaving = true;
      const response: any = await this.apiService.PageAtcsApi?.apiV2PageAtcsAdminUpdatePageContentPost(this.tempHelpContent);
      this.eventCtrl.emit('show-snackbar', 'success', 'Content updated');
      this.eventCtrl.emit('reload-page-settings');
      this.close();
    } catch (err: any) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error getting page container: ' + err.response?.status);
      this.ai.trackException('Error updating page content: ' + err);
    } finally {
      this.isSaving = false;
    }
  }

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  get isTesting() {
    const _local = window.location.href.indexOf('https://localhost:44') == 0;
    return _local;
  }

}
